// extracted by mini-css-extract-plugin
export default {"promote_box":"index_promote_box_-4EhE"};